// src/components/admin/page-management/section-forms/HeroForm.js
import React from 'react';
import ImageUploader from '../ImageUploader';

const HeroForm = ({ content, updateContent, pageSlug }) => {
  const handleImageUpload = (imagePath) => {
    updateContent('imageUrl', imagePath);
  };

  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Hero Section</h3>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Title</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.title || ''}
          onChange={(e) => updateContent('title', e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Subtitle</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.subtitle || ''}
          onChange={(e) => updateContent('subtitle', e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Text</label>
        <textarea
          className="w-full p-2 border rounded"
          rows="3"
          value={content?.text || ''}
          onChange={(e) => updateContent('text', e.target.value)}
        ></textarea>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Button Text</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.buttonText || ''}
          onChange={(e) => updateContent('buttonText', e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Button Link</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.buttonLink || ''}
          onChange={(e) => updateContent('buttonLink', e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Button Style</label>
        <select
          className="w-full p-2 border rounded"
          value={content?.buttonStyle || 'primary'}
          onChange={(e) => updateContent('buttonStyle', e.target.value)}
        >
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
          <option value="outline">Outline</option>
          <option value="link">Link</option>
        </select>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Image URL</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          value={content?.imageUrl || ''}
          onChange={(e) => updateContent('imageUrl', e.target.value)}
        />
        <ImageUploader onImageUpload={handleImageUpload} pageSlug={pageSlug} />
      </div>
      
      {content?.imageUrl && (
        <div className="mt-2 p-2 border rounded">
          <p className="text-sm font-medium mb-2">Preview:</p>
          <img 
            src={content.imageUrl} 
            alt="Hero Preview" 
            className="max-w-full h-auto max-h-32"
          />
        </div>
      )}
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Alignment</label>
        <select
          className="w-full p-2 border rounded"
          value={content?.alignment || 'center'}
          onChange={(e) => updateContent('alignment', e.target.value)}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>
    </div>
  );
};

export default HeroForm;



